'use strict';

var angular = require('angular');
var LegWizardController = function LegWizardController($scope, wizardHandler, validationService) {
  $scope.model = {};
  $scope.$on('wizard:stepChanged', function (event, stepEntered) {
    $scope.$broadcast('scheduleChange:stepEntered', stepEntered.step.title);
  });
  $scope.sponsorFlightForecastBackButton = $scope.isFlightsWizard() ? '' : 'Back';
  $scope.initWizard = function () {
    if ($scope.isFlightsWizard()) {
      $scope.model.isNextDisabled = true;
      wizardHandler.wizard().goTo('Sponsor Flight Forecast');
    }
  };
  $scope.validateLegStepSponsorship = function () {
    return validationService.validateStepSponsorship();
  };
  $scope.validateFlightStepSponsorship = function () {
    return validationService.validateStepSponsorshipFlight();
  };
  $scope.finishedWizard = angular.noop;
};
LegWizardController.$inject = ['$scope', 'WizardHandler', 'ValidationService'];
module.exports = LegWizardController;